// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1920px) and (max-width: 2560px){
    .testing-class-for-fixed-header{
        max-height: 75vh !important;
    }
    .side_bar .side-bar-container .top_menubar ul li{
        margin: 25px 0 0!important;
    }
}

@media (min-width: 1801px) and (max-width: 1920px){
    .testing-class-for-fixed-header{
        max-height: 75vh !important;
    }
    .side_bar .side-bar-container .top_menubar ul li{
        margin: 20px 0 0!important;
    }
}

@media (min-width:1681px) and (max-width:1800px){
    .testing-class-for-fixed-header{
        max-height: 75vh !important;
    }
    .side_bar .side-bar-container .top_menubar ul li{
        margin: 15px 0 0!important;
    }
}

@media (min-width: 1600px) and (max-width: 1680px){
    .testing-class-for-fixed-header{
        max-height: 75vh !important;
    }
    .side_bar .side-bar-container .top_menubar ul li{
        margin: 12px 0 0!important;
    }
}

@media (min-width: 1441px) and (max-width: 1599px){
    .testing-class-for-fixed-header{
        max-height: 75vh !important;
    }
    .side_bar .side-bar-container .top_menubar ul li{
        margin: 5px 0 0!important;
    }
}

@media (min-width: 1400px) and (max-width: 1440px){
    .testing-class-for-fixed-header{
        max-height: 75vh !important;
    }
    .side_bar .side-bar-container .top_menubar ul li{
        margin: 5px 0 0!important;
    }
}
@media (min-width: 1300px) and (max-width: 1366px){
    .testing-class-for-fixed-header{
        max-height: 75vh !important;
    }
    .side_bar .side-bar-container .top_menubar ul li{
        margin: 5px 0 0!important;
    }
}

@media (min-width: 1200px) and (max-width: 1200px) {
    .testing-class-for-fixed-header{
        max-height: 465px!important;
    }
    .side_bar .side-bar-container .top_menubar ul li{
        margin: 5px 0 0!important;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/responsive.css"],"names":[],"mappings":"AAAA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["@media (min-width: 1920px) and (max-width: 2560px){\n    .testing-class-for-fixed-header{\n        max-height: 75vh !important;\n    }\n    .side_bar .side-bar-container .top_menubar ul li{\n        margin: 25px 0 0!important;\n    }\n}\n\n@media (min-width: 1801px) and (max-width: 1920px){\n    .testing-class-for-fixed-header{\n        max-height: 75vh !important;\n    }\n    .side_bar .side-bar-container .top_menubar ul li{\n        margin: 20px 0 0!important;\n    }\n}\n\n@media (min-width:1681px) and (max-width:1800px){\n    .testing-class-for-fixed-header{\n        max-height: 75vh !important;\n    }\n    .side_bar .side-bar-container .top_menubar ul li{\n        margin: 15px 0 0!important;\n    }\n}\n\n@media (min-width: 1600px) and (max-width: 1680px){\n    .testing-class-for-fixed-header{\n        max-height: 75vh !important;\n    }\n    .side_bar .side-bar-container .top_menubar ul li{\n        margin: 12px 0 0!important;\n    }\n}\n\n@media (min-width: 1441px) and (max-width: 1599px){\n    .testing-class-for-fixed-header{\n        max-height: 75vh !important;\n    }\n    .side_bar .side-bar-container .top_menubar ul li{\n        margin: 5px 0 0!important;\n    }\n}\n\n@media (min-width: 1400px) and (max-width: 1440px){\n    .testing-class-for-fixed-header{\n        max-height: 75vh !important;\n    }\n    .side_bar .side-bar-container .top_menubar ul li{\n        margin: 5px 0 0!important;\n    }\n}\n@media (min-width: 1300px) and (max-width: 1366px){\n    .testing-class-for-fixed-header{\n        max-height: 75vh !important;\n    }\n    .side_bar .side-bar-container .top_menubar ul li{\n        margin: 5px 0 0!important;\n    }\n}\n\n@media (min-width: 1200px) and (max-width: 1200px) {\n    .testing-class-for-fixed-header{\n        max-height: 465px!important;\n    }\n    .side_bar .side-bar-container .top_menubar ul li{\n        margin: 5px 0 0!important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
